// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__GEH-V","date":"style__date__F8EPf","pageNumber":"style__pageNumber__D3F+N"};